// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import {
  backendApiAuthenticationGetUser,
  backendApiAuthenticationLogin,
  backendApiAuthenticationLogout,
  backendApiAuthenticationRefresh,
  backendApiCaslGetRules,
  backendApiContactRequestsCreate,
  backendApiHealthCheck,
  backendApiInvitationsAccept,
  backendApiInvitationsReinvite,
  backendApiOrganizationsCreate,
  backendApiOrganizationsCreateOrganizationUser,
  backendApiOrganizationsFindAll,
  backendApiOrganizationsFindOne,
  backendApiOrganizationsFindOneOrganizationUser,
  backendApiOrganizationsRemove,
  backendApiOrganizationsRemoveOrganizationUser,
  backendApiOrganizationsUpdate,
  backendApiOrganizationsUpdateOrganizationUser,
  backendApiParkAndRideFacilitiesCreate,
  backendApiParkAndRideFacilitiesExportCsv,
  backendApiParkAndRideFacilitiesFindAll,
  backendApiParkAndRideFacilitiesFindAllAudits,
  backendApiParkAndRideFacilitiesFindOne,
  backendApiParkAndRideFacilitiesFindOneAudit,
  backendApiParkAndRideFacilitiesRemove,
  backendApiParkAndRideFacilitiesUpdate,
  backendApiParkingDataFindAllLatestParkAndRideFacilityData,
  backendApiParkingDataFindAllLatestParkingFacilityData,
  backendApiParkingDataFindAllParkAndRideFacilityData,
  backendApiParkingDataFindAllParkingFacilityData,
  backendApiParkingFacilitiesCreate,
  backendApiParkingFacilitiesExportCsv,
  backendApiParkingFacilitiesFindAll,
  backendApiParkingFacilitiesFindAllAudits,
  backendApiParkingFacilitiesFindOne,
  backendApiParkingFacilitiesFindOneAudit,
  backendApiParkingFacilitiesRemove,
  backendApiParkingFacilitiesUpdate,
  backendApiPasswordResetInitialize,
  backendApiPasswordResetSubmit,
  backendApiStationsCreate,
  backendApiStationsFindAll,
  backendApiStationsFindAllAudits,
  backendApiStationsFindOne,
  backendApiStationsFindOneAudit,
  backendApiStationsRemove,
  backendApiStationsUpdate,
  backendApiUsersCreate,
  backendApiUsersFindAll,
  backendApiUsersFindOne,
  backendApiUsersRemove,
  backendApiUsersUpdate,
  type Options,
} from '../sdk.gen';
import type {
  AuthenticationGetUserData,
  AuthenticationGetUserResponse,
  AuthenticationLoginData,
  AuthenticationLoginResponse,
  AuthenticationLogoutData,
  AuthenticationLogoutResponse,
  AuthenticationRefreshData,
  CaslGetRulesData,
  CaslGetRulesResponse,
  ContactRequestsCreateData,
  HealthCheckData,
  HealthCheckError,
  HealthCheckResponse,
  InvitationsAcceptData,
  InvitationsAcceptResponse,
  InvitationsReinviteData,
  InvitationsReinviteResponse,
  OrganizationsCreateData,
  OrganizationsCreateOrganizationUserData,
  OrganizationsCreateOrganizationUserResponse,
  OrganizationsCreateResponse,
  OrganizationsFindAllData,
  OrganizationsFindAllResponse,
  OrganizationsFindOneData,
  OrganizationsFindOneOrganizationUserData,
  OrganizationsFindOneOrganizationUserResponse,
  OrganizationsFindOneResponse,
  OrganizationsRemoveData,
  OrganizationsRemoveOrganizationUserData,
  OrganizationsRemoveOrganizationUserResponse,
  OrganizationsRemoveResponse,
  OrganizationsUpdateData,
  OrganizationsUpdateOrganizationUserData,
  OrganizationsUpdateOrganizationUserResponse,
  OrganizationsUpdateResponse,
  ParkAndRideFacilitiesCreateData,
  ParkAndRideFacilitiesCreateResponse,
  ParkAndRideFacilitiesExportCsvData,
  ParkAndRideFacilitiesFindAllAuditsData,
  ParkAndRideFacilitiesFindAllAuditsResponse,
  ParkAndRideFacilitiesFindAllData,
  ParkAndRideFacilitiesFindAllResponse,
  ParkAndRideFacilitiesFindOneAuditData,
  ParkAndRideFacilitiesFindOneAuditResponse,
  ParkAndRideFacilitiesFindOneData,
  ParkAndRideFacilitiesFindOneResponse,
  ParkAndRideFacilitiesRemoveData,
  ParkAndRideFacilitiesRemoveResponse,
  ParkAndRideFacilitiesUpdateData,
  ParkAndRideFacilitiesUpdateResponse,
  ParkingDataFindAllLatestParkAndRideFacilityDataData,
  ParkingDataFindAllLatestParkAndRideFacilityDataResponse,
  ParkingDataFindAllLatestParkingFacilityDataData,
  ParkingDataFindAllLatestParkingFacilityDataResponse,
  ParkingDataFindAllParkAndRideFacilityDataData,
  ParkingDataFindAllParkAndRideFacilityDataResponse,
  ParkingDataFindAllParkingFacilityDataData,
  ParkingDataFindAllParkingFacilityDataResponse,
  ParkingFacilitiesCreateData,
  ParkingFacilitiesCreateResponse,
  ParkingFacilitiesExportCsvData,
  ParkingFacilitiesFindAllAuditsData,
  ParkingFacilitiesFindAllAuditsResponse,
  ParkingFacilitiesFindAllData,
  ParkingFacilitiesFindAllResponse,
  ParkingFacilitiesFindOneAuditData,
  ParkingFacilitiesFindOneAuditResponse,
  ParkingFacilitiesFindOneData,
  ParkingFacilitiesFindOneResponse,
  ParkingFacilitiesRemoveData,
  ParkingFacilitiesRemoveResponse,
  ParkingFacilitiesUpdateData,
  ParkingFacilitiesUpdateResponse,
  PasswordResetInitializeData,
  PasswordResetSubmitData,
  PasswordResetSubmitResponse,
  StationsCreateData,
  StationsCreateResponse,
  StationsFindAllAuditsData,
  StationsFindAllAuditsResponse,
  StationsFindAllData,
  StationsFindAllResponse,
  StationsFindOneAuditData,
  StationsFindOneAuditResponse,
  StationsFindOneData,
  StationsFindOneResponse,
  StationsRemoveData,
  StationsRemoveResponse,
  StationsUpdateData,
  StationsUpdateResponse,
  UsersCreateData,
  UsersCreateResponse,
  UsersFindAllData,
  UsersFindAllResponse,
  UsersFindOneData,
  UsersFindOneResponse,
  UsersRemoveData,
  UsersRemoveResponse,
  UsersUpdateData,
  UsersUpdateResponse,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const backendApiHealthCheckQueryKey = (options?: Options<HealthCheckData>) =>
  createQueryKey('healthCheck', options);

export const backendApiHealthCheckOptions = (options?: Options<HealthCheckData>) =>
  queryOptions<
    HealthCheckResponse,
    HealthCheckError,
    HealthCheckResponse,
    ReturnType<typeof backendApiHealthCheckQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiHealthCheck({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiHealthCheckQueryKey(options),
  });

export const backendApiAuthenticationLogoutMutation = (
  options?: Partial<Options<AuthenticationLogoutData>>,
): UseMutationOptions<AuthenticationLogoutResponse, DefaultError, Options<AuthenticationLogoutData>> => {
  const mutationOptions: UseMutationOptions<
    AuthenticationLogoutResponse,
    DefaultError,
    Options<AuthenticationLogoutData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiAuthenticationLogout({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiAuthenticationGetUserQueryKey = (options?: Options<AuthenticationGetUserData>) =>
  createQueryKey('authenticationGetUser', options);

export const backendApiAuthenticationGetUserOptions = (options?: Options<AuthenticationGetUserData>) =>
  queryOptions<
    AuthenticationGetUserResponse,
    DefaultError,
    AuthenticationGetUserResponse,
    ReturnType<typeof backendApiAuthenticationGetUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationGetUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationGetUserQueryKey(options),
  });

export const backendApiAuthenticationLoginQueryKey = (options: Options<AuthenticationLoginData>) =>
  createQueryKey('authenticationLogin', options);

export const backendApiAuthenticationLoginOptions = (options: Options<AuthenticationLoginData>) =>
  queryOptions<
    AuthenticationLoginResponse,
    DefaultError,
    AuthenticationLoginResponse,
    ReturnType<typeof backendApiAuthenticationLoginQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationLogin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationLoginQueryKey(options),
  });

export const backendApiAuthenticationLoginMutation = (
  options?: Partial<Options<AuthenticationLoginData>>,
): UseMutationOptions<AuthenticationLoginResponse, DefaultError, Options<AuthenticationLoginData>> => {
  const mutationOptions: UseMutationOptions<
    AuthenticationLoginResponse,
    DefaultError,
    Options<AuthenticationLoginData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiAuthenticationLogin({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiAuthenticationRefreshQueryKey = (options: Options<AuthenticationRefreshData>) =>
  createQueryKey('authenticationRefresh', options);

export const backendApiAuthenticationRefreshOptions = (options: Options<AuthenticationRefreshData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof backendApiAuthenticationRefreshQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiAuthenticationRefresh({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiAuthenticationRefreshQueryKey(options),
  });

export const backendApiAuthenticationRefreshMutation = (
  options?: Partial<Options<AuthenticationRefreshData>>,
): UseMutationOptions<unknown, DefaultError, Options<AuthenticationRefreshData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AuthenticationRefreshData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiAuthenticationRefresh({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiPasswordResetInitializeQueryKey = (options: Options<PasswordResetInitializeData>) =>
  createQueryKey('passwordResetInitialize', options);

export const backendApiPasswordResetInitializeOptions = (options: Options<PasswordResetInitializeData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof backendApiPasswordResetInitializeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiPasswordResetInitialize({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiPasswordResetInitializeQueryKey(options),
  });

export const backendApiPasswordResetInitializeMutation = (
  options?: Partial<Options<PasswordResetInitializeData>>,
): UseMutationOptions<unknown, DefaultError, Options<PasswordResetInitializeData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PasswordResetInitializeData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiPasswordResetInitialize({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiPasswordResetSubmitMutation = (
  options?: Partial<Options<PasswordResetSubmitData>>,
): UseMutationOptions<PasswordResetSubmitResponse, DefaultError, Options<PasswordResetSubmitData>> => {
  const mutationOptions: UseMutationOptions<
    PasswordResetSubmitResponse,
    DefaultError,
    Options<PasswordResetSubmitData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiPasswordResetSubmit({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiUsersFindAllQueryKey = (options?: Options<UsersFindAllData>) =>
  createQueryKey('usersFindAll', options);

export const backendApiUsersFindAllOptions = (options?: Options<UsersFindAllData>) =>
  queryOptions<
    UsersFindAllResponse,
    DefaultError,
    UsersFindAllResponse,
    ReturnType<typeof backendApiUsersFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiUsersFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiUsersFindAllQueryKey(options),
  });

export const backendApiUsersCreateQueryKey = (options: Options<UsersCreateData>) =>
  createQueryKey('usersCreate', options);

export const backendApiUsersCreateOptions = (options: Options<UsersCreateData>) =>
  queryOptions<
    UsersCreateResponse,
    DefaultError,
    UsersCreateResponse,
    ReturnType<typeof backendApiUsersCreateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiUsersCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiUsersCreateQueryKey(options),
  });

export const backendApiUsersCreateMutation = (
  options?: Partial<Options<UsersCreateData>>,
): UseMutationOptions<UsersCreateResponse, DefaultError, Options<UsersCreateData>> => {
  const mutationOptions: UseMutationOptions<UsersCreateResponse, DefaultError, Options<UsersCreateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiUsersCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiUsersRemoveMutation = (
  options?: Partial<Options<UsersRemoveData>>,
): UseMutationOptions<UsersRemoveResponse, DefaultError, Options<UsersRemoveData>> => {
  const mutationOptions: UseMutationOptions<UsersRemoveResponse, DefaultError, Options<UsersRemoveData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiUsersRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiUsersFindOneQueryKey = (options: Options<UsersFindOneData>) =>
  createQueryKey('usersFindOne', options);

export const backendApiUsersFindOneOptions = (options: Options<UsersFindOneData>) =>
  queryOptions<
    UsersFindOneResponse,
    DefaultError,
    UsersFindOneResponse,
    ReturnType<typeof backendApiUsersFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiUsersFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiUsersFindOneQueryKey(options),
  });

export const backendApiUsersUpdateMutation = (
  options?: Partial<Options<UsersUpdateData>>,
): UseMutationOptions<UsersUpdateResponse, DefaultError, Options<UsersUpdateData>> => {
  const mutationOptions: UseMutationOptions<UsersUpdateResponse, DefaultError, Options<UsersUpdateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiUsersUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiCaslGetRulesQueryKey = (options?: Options<CaslGetRulesData>) =>
  createQueryKey('caslGetRules', options);

export const backendApiCaslGetRulesOptions = (options?: Options<CaslGetRulesData>) =>
  queryOptions<
    CaslGetRulesResponse,
    DefaultError,
    CaslGetRulesResponse,
    ReturnType<typeof backendApiCaslGetRulesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiCaslGetRules({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiCaslGetRulesQueryKey(options),
  });

export const backendApiInvitationsReinviteQueryKey = (options: Options<InvitationsReinviteData>) =>
  createQueryKey('invitationsReinvite', options);

export const backendApiInvitationsReinviteOptions = (options: Options<InvitationsReinviteData>) =>
  queryOptions<
    InvitationsReinviteResponse,
    DefaultError,
    InvitationsReinviteResponse,
    ReturnType<typeof backendApiInvitationsReinviteQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiInvitationsReinvite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiInvitationsReinviteQueryKey(options),
  });

export const backendApiInvitationsReinviteMutation = (
  options?: Partial<Options<InvitationsReinviteData>>,
): UseMutationOptions<InvitationsReinviteResponse, DefaultError, Options<InvitationsReinviteData>> => {
  const mutationOptions: UseMutationOptions<
    InvitationsReinviteResponse,
    DefaultError,
    Options<InvitationsReinviteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiInvitationsReinvite({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiInvitationsAcceptMutation = (
  options?: Partial<Options<InvitationsAcceptData>>,
): UseMutationOptions<InvitationsAcceptResponse, DefaultError, Options<InvitationsAcceptData>> => {
  const mutationOptions: UseMutationOptions<InvitationsAcceptResponse, DefaultError, Options<InvitationsAcceptData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiInvitationsAccept({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsFindAllQueryKey = (options?: Options<OrganizationsFindAllData>) =>
  createQueryKey('organizationsFindAll', options);

export const backendApiOrganizationsFindAllOptions = (options?: Options<OrganizationsFindAllData>) =>
  queryOptions<
    OrganizationsFindAllResponse,
    DefaultError,
    OrganizationsFindAllResponse,
    ReturnType<typeof backendApiOrganizationsFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiOrganizationsFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiOrganizationsFindAllQueryKey(options),
  });

export const backendApiOrganizationsCreateQueryKey = (options: Options<OrganizationsCreateData>) =>
  createQueryKey('organizationsCreate', options);

export const backendApiOrganizationsCreateOptions = (options: Options<OrganizationsCreateData>) =>
  queryOptions<
    OrganizationsCreateResponse,
    DefaultError,
    OrganizationsCreateResponse,
    ReturnType<typeof backendApiOrganizationsCreateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiOrganizationsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiOrganizationsCreateQueryKey(options),
  });

export const backendApiOrganizationsCreateMutation = (
  options?: Partial<Options<OrganizationsCreateData>>,
): UseMutationOptions<OrganizationsCreateResponse, DefaultError, Options<OrganizationsCreateData>> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsCreateResponse,
    DefaultError,
    Options<OrganizationsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsRemoveMutation = (
  options?: Partial<Options<OrganizationsRemoveData>>,
): UseMutationOptions<OrganizationsRemoveResponse, DefaultError, Options<OrganizationsRemoveData>> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsRemoveResponse,
    DefaultError,
    Options<OrganizationsRemoveData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsFindOneQueryKey = (options: Options<OrganizationsFindOneData>) =>
  createQueryKey('organizationsFindOne', options);

export const backendApiOrganizationsFindOneOptions = (options: Options<OrganizationsFindOneData>) =>
  queryOptions<
    OrganizationsFindOneResponse,
    DefaultError,
    OrganizationsFindOneResponse,
    ReturnType<typeof backendApiOrganizationsFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiOrganizationsFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiOrganizationsFindOneQueryKey(options),
  });

export const backendApiOrganizationsUpdateMutation = (
  options?: Partial<Options<OrganizationsUpdateData>>,
): UseMutationOptions<OrganizationsUpdateResponse, DefaultError, Options<OrganizationsUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsUpdateResponse,
    DefaultError,
    Options<OrganizationsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsCreateOrganizationUserQueryKey = (
  options: Options<OrganizationsCreateOrganizationUserData>,
) => createQueryKey('organizationsCreateOrganizationUser', options);

export const backendApiOrganizationsCreateOrganizationUserOptions = (
  options: Options<OrganizationsCreateOrganizationUserData>,
) =>
  queryOptions<
    OrganizationsCreateOrganizationUserResponse,
    DefaultError,
    OrganizationsCreateOrganizationUserResponse,
    ReturnType<typeof backendApiOrganizationsCreateOrganizationUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiOrganizationsCreateOrganizationUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiOrganizationsCreateOrganizationUserQueryKey(options),
  });

export const backendApiOrganizationsCreateOrganizationUserMutation = (
  options?: Partial<Options<OrganizationsCreateOrganizationUserData>>,
): UseMutationOptions<
  OrganizationsCreateOrganizationUserResponse,
  DefaultError,
  Options<OrganizationsCreateOrganizationUserData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsCreateOrganizationUserResponse,
    DefaultError,
    Options<OrganizationsCreateOrganizationUserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsCreateOrganizationUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsRemoveOrganizationUserMutation = (
  options?: Partial<Options<OrganizationsRemoveOrganizationUserData>>,
): UseMutationOptions<
  OrganizationsRemoveOrganizationUserResponse,
  DefaultError,
  Options<OrganizationsRemoveOrganizationUserData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsRemoveOrganizationUserResponse,
    DefaultError,
    Options<OrganizationsRemoveOrganizationUserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsRemoveOrganizationUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiOrganizationsFindOneOrganizationUserQueryKey = (
  options: Options<OrganizationsFindOneOrganizationUserData>,
) => createQueryKey('organizationsFindOneOrganizationUser', options);

export const backendApiOrganizationsFindOneOrganizationUserOptions = (
  options: Options<OrganizationsFindOneOrganizationUserData>,
) =>
  queryOptions<
    OrganizationsFindOneOrganizationUserResponse,
    DefaultError,
    OrganizationsFindOneOrganizationUserResponse,
    ReturnType<typeof backendApiOrganizationsFindOneOrganizationUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiOrganizationsFindOneOrganizationUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiOrganizationsFindOneOrganizationUserQueryKey(options),
  });

export const backendApiOrganizationsUpdateOrganizationUserMutation = (
  options?: Partial<Options<OrganizationsUpdateOrganizationUserData>>,
): UseMutationOptions<
  OrganizationsUpdateOrganizationUserResponse,
  DefaultError,
  Options<OrganizationsUpdateOrganizationUserData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsUpdateOrganizationUserResponse,
    DefaultError,
    Options<OrganizationsUpdateOrganizationUserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiOrganizationsUpdateOrganizationUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiParkingFacilitiesFindAllQueryKey = (options?: Options<ParkingFacilitiesFindAllData>) =>
  createQueryKey('parkingFacilitiesFindAll', options);

export const backendApiParkingFacilitiesFindAllOptions = (options?: Options<ParkingFacilitiesFindAllData>) =>
  queryOptions<
    ParkingFacilitiesFindAllResponse,
    DefaultError,
    ParkingFacilitiesFindAllResponse,
    ReturnType<typeof backendApiParkingFacilitiesFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkingFacilitiesFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkingFacilitiesFindAllQueryKey(options),
  });

export const backendApiParkingFacilitiesCreateQueryKey = (options: Options<ParkingFacilitiesCreateData>) =>
  createQueryKey('parkingFacilitiesCreate', options);

export const backendApiParkingFacilitiesCreateOptions = (options: Options<ParkingFacilitiesCreateData>) =>
  queryOptions<
    ParkingFacilitiesCreateResponse,
    DefaultError,
    ParkingFacilitiesCreateResponse,
    ReturnType<typeof backendApiParkingFacilitiesCreateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkingFacilitiesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkingFacilitiesCreateQueryKey(options),
  });

export const backendApiParkingFacilitiesCreateMutation = (
  options?: Partial<Options<ParkingFacilitiesCreateData>>,
): UseMutationOptions<ParkingFacilitiesCreateResponse, DefaultError, Options<ParkingFacilitiesCreateData>> => {
  const mutationOptions: UseMutationOptions<
    ParkingFacilitiesCreateResponse,
    DefaultError,
    Options<ParkingFacilitiesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiParkingFacilitiesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiParkingFacilitiesExportCsvQueryKey = (options?: Options<ParkingFacilitiesExportCsvData>) =>
  createQueryKey('parkingFacilitiesExportCsv', options);

export const backendApiParkingFacilitiesExportCsvOptions = (options?: Options<ParkingFacilitiesExportCsvData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof backendApiParkingFacilitiesExportCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkingFacilitiesExportCsv({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkingFacilitiesExportCsvQueryKey(options),
  });

export const backendApiParkingFacilitiesRemoveMutation = (
  options?: Partial<Options<ParkingFacilitiesRemoveData>>,
): UseMutationOptions<ParkingFacilitiesRemoveResponse, DefaultError, Options<ParkingFacilitiesRemoveData>> => {
  const mutationOptions: UseMutationOptions<
    ParkingFacilitiesRemoveResponse,
    DefaultError,
    Options<ParkingFacilitiesRemoveData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiParkingFacilitiesRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiParkingFacilitiesFindOneQueryKey = (options: Options<ParkingFacilitiesFindOneData>) =>
  createQueryKey('parkingFacilitiesFindOne', options);

export const backendApiParkingFacilitiesFindOneOptions = (options: Options<ParkingFacilitiesFindOneData>) =>
  queryOptions<
    ParkingFacilitiesFindOneResponse,
    DefaultError,
    ParkingFacilitiesFindOneResponse,
    ReturnType<typeof backendApiParkingFacilitiesFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkingFacilitiesFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkingFacilitiesFindOneQueryKey(options),
  });

export const backendApiParkingFacilitiesUpdateMutation = (
  options?: Partial<Options<ParkingFacilitiesUpdateData>>,
): UseMutationOptions<ParkingFacilitiesUpdateResponse, DefaultError, Options<ParkingFacilitiesUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    ParkingFacilitiesUpdateResponse,
    DefaultError,
    Options<ParkingFacilitiesUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiParkingFacilitiesUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiParkingFacilitiesFindAllAuditsQueryKey = (
  options: Options<ParkingFacilitiesFindAllAuditsData>,
) => createQueryKey('parkingFacilitiesFindAllAudits', options);

export const backendApiParkingFacilitiesFindAllAuditsOptions = (options: Options<ParkingFacilitiesFindAllAuditsData>) =>
  queryOptions<
    ParkingFacilitiesFindAllAuditsResponse,
    DefaultError,
    ParkingFacilitiesFindAllAuditsResponse,
    ReturnType<typeof backendApiParkingFacilitiesFindAllAuditsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkingFacilitiesFindAllAudits({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkingFacilitiesFindAllAuditsQueryKey(options),
  });

export const backendApiParkingFacilitiesFindOneAuditQueryKey = (options: Options<ParkingFacilitiesFindOneAuditData>) =>
  createQueryKey('parkingFacilitiesFindOneAudit', options);

export const backendApiParkingFacilitiesFindOneAuditOptions = (options: Options<ParkingFacilitiesFindOneAuditData>) =>
  queryOptions<
    ParkingFacilitiesFindOneAuditResponse,
    DefaultError,
    ParkingFacilitiesFindOneAuditResponse,
    ReturnType<typeof backendApiParkingFacilitiesFindOneAuditQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkingFacilitiesFindOneAudit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkingFacilitiesFindOneAuditQueryKey(options),
  });

export const backendApiStationsFindAllQueryKey = (options?: Options<StationsFindAllData>) =>
  createQueryKey('stationsFindAll', options);

export const backendApiStationsFindAllOptions = (options?: Options<StationsFindAllData>) =>
  queryOptions<
    StationsFindAllResponse,
    DefaultError,
    StationsFindAllResponse,
    ReturnType<typeof backendApiStationsFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiStationsFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiStationsFindAllQueryKey(options),
  });

export const backendApiStationsCreateQueryKey = (options: Options<StationsCreateData>) =>
  createQueryKey('stationsCreate', options);

export const backendApiStationsCreateOptions = (options: Options<StationsCreateData>) =>
  queryOptions<
    StationsCreateResponse,
    DefaultError,
    StationsCreateResponse,
    ReturnType<typeof backendApiStationsCreateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiStationsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiStationsCreateQueryKey(options),
  });

export const backendApiStationsCreateMutation = (
  options?: Partial<Options<StationsCreateData>>,
): UseMutationOptions<StationsCreateResponse, DefaultError, Options<StationsCreateData>> => {
  const mutationOptions: UseMutationOptions<StationsCreateResponse, DefaultError, Options<StationsCreateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiStationsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiStationsRemoveMutation = (
  options?: Partial<Options<StationsRemoveData>>,
): UseMutationOptions<StationsRemoveResponse, DefaultError, Options<StationsRemoveData>> => {
  const mutationOptions: UseMutationOptions<StationsRemoveResponse, DefaultError, Options<StationsRemoveData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiStationsRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiStationsFindOneQueryKey = (options: Options<StationsFindOneData>) =>
  createQueryKey('stationsFindOne', options);

export const backendApiStationsFindOneOptions = (options: Options<StationsFindOneData>) =>
  queryOptions<
    StationsFindOneResponse,
    DefaultError,
    StationsFindOneResponse,
    ReturnType<typeof backendApiStationsFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiStationsFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiStationsFindOneQueryKey(options),
  });

export const backendApiStationsUpdateMutation = (
  options?: Partial<Options<StationsUpdateData>>,
): UseMutationOptions<StationsUpdateResponse, DefaultError, Options<StationsUpdateData>> => {
  const mutationOptions: UseMutationOptions<StationsUpdateResponse, DefaultError, Options<StationsUpdateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiStationsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiStationsFindAllAuditsQueryKey = (options: Options<StationsFindAllAuditsData>) =>
  createQueryKey('stationsFindAllAudits', options);

export const backendApiStationsFindAllAuditsOptions = (options: Options<StationsFindAllAuditsData>) =>
  queryOptions<
    StationsFindAllAuditsResponse,
    DefaultError,
    StationsFindAllAuditsResponse,
    ReturnType<typeof backendApiStationsFindAllAuditsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiStationsFindAllAudits({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiStationsFindAllAuditsQueryKey(options),
  });

export const backendApiStationsFindOneAuditQueryKey = (options: Options<StationsFindOneAuditData>) =>
  createQueryKey('stationsFindOneAudit', options);

export const backendApiStationsFindOneAuditOptions = (options: Options<StationsFindOneAuditData>) =>
  queryOptions<
    StationsFindOneAuditResponse,
    DefaultError,
    StationsFindOneAuditResponse,
    ReturnType<typeof backendApiStationsFindOneAuditQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiStationsFindOneAudit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiStationsFindOneAuditQueryKey(options),
  });

export const backendApiParkAndRideFacilitiesFindAllQueryKey = (options?: Options<ParkAndRideFacilitiesFindAllData>) =>
  createQueryKey('parkAndRideFacilitiesFindAll', options);

export const backendApiParkAndRideFacilitiesFindAllOptions = (options?: Options<ParkAndRideFacilitiesFindAllData>) =>
  queryOptions<
    ParkAndRideFacilitiesFindAllResponse,
    DefaultError,
    ParkAndRideFacilitiesFindAllResponse,
    ReturnType<typeof backendApiParkAndRideFacilitiesFindAllQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkAndRideFacilitiesFindAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkAndRideFacilitiesFindAllQueryKey(options),
  });

export const backendApiParkAndRideFacilitiesCreateQueryKey = (options: Options<ParkAndRideFacilitiesCreateData>) =>
  createQueryKey('parkAndRideFacilitiesCreate', options);

export const backendApiParkAndRideFacilitiesCreateOptions = (options: Options<ParkAndRideFacilitiesCreateData>) =>
  queryOptions<
    ParkAndRideFacilitiesCreateResponse,
    DefaultError,
    ParkAndRideFacilitiesCreateResponse,
    ReturnType<typeof backendApiParkAndRideFacilitiesCreateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkAndRideFacilitiesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkAndRideFacilitiesCreateQueryKey(options),
  });

export const backendApiParkAndRideFacilitiesCreateMutation = (
  options?: Partial<Options<ParkAndRideFacilitiesCreateData>>,
): UseMutationOptions<ParkAndRideFacilitiesCreateResponse, DefaultError, Options<ParkAndRideFacilitiesCreateData>> => {
  const mutationOptions: UseMutationOptions<
    ParkAndRideFacilitiesCreateResponse,
    DefaultError,
    Options<ParkAndRideFacilitiesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiParkAndRideFacilitiesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiParkAndRideFacilitiesExportCsvQueryKey = (
  options?: Options<ParkAndRideFacilitiesExportCsvData>,
) => createQueryKey('parkAndRideFacilitiesExportCsv', options);

export const backendApiParkAndRideFacilitiesExportCsvOptions = (
  options?: Options<ParkAndRideFacilitiesExportCsvData>,
) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof backendApiParkAndRideFacilitiesExportCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkAndRideFacilitiesExportCsv({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkAndRideFacilitiesExportCsvQueryKey(options),
  });

export const backendApiParkAndRideFacilitiesRemoveMutation = (
  options?: Partial<Options<ParkAndRideFacilitiesRemoveData>>,
): UseMutationOptions<ParkAndRideFacilitiesRemoveResponse, DefaultError, Options<ParkAndRideFacilitiesRemoveData>> => {
  const mutationOptions: UseMutationOptions<
    ParkAndRideFacilitiesRemoveResponse,
    DefaultError,
    Options<ParkAndRideFacilitiesRemoveData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiParkAndRideFacilitiesRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiParkAndRideFacilitiesFindOneQueryKey = (options: Options<ParkAndRideFacilitiesFindOneData>) =>
  createQueryKey('parkAndRideFacilitiesFindOne', options);

export const backendApiParkAndRideFacilitiesFindOneOptions = (options: Options<ParkAndRideFacilitiesFindOneData>) =>
  queryOptions<
    ParkAndRideFacilitiesFindOneResponse,
    DefaultError,
    ParkAndRideFacilitiesFindOneResponse,
    ReturnType<typeof backendApiParkAndRideFacilitiesFindOneQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkAndRideFacilitiesFindOne({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkAndRideFacilitiesFindOneQueryKey(options),
  });

export const backendApiParkAndRideFacilitiesUpdateMutation = (
  options?: Partial<Options<ParkAndRideFacilitiesUpdateData>>,
): UseMutationOptions<ParkAndRideFacilitiesUpdateResponse, DefaultError, Options<ParkAndRideFacilitiesUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    ParkAndRideFacilitiesUpdateResponse,
    DefaultError,
    Options<ParkAndRideFacilitiesUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiParkAndRideFacilitiesUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiParkAndRideFacilitiesFindAllAuditsQueryKey = (
  options: Options<ParkAndRideFacilitiesFindAllAuditsData>,
) => createQueryKey('parkAndRideFacilitiesFindAllAudits', options);

export const backendApiParkAndRideFacilitiesFindAllAuditsOptions = (
  options: Options<ParkAndRideFacilitiesFindAllAuditsData>,
) =>
  queryOptions<
    ParkAndRideFacilitiesFindAllAuditsResponse,
    DefaultError,
    ParkAndRideFacilitiesFindAllAuditsResponse,
    ReturnType<typeof backendApiParkAndRideFacilitiesFindAllAuditsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkAndRideFacilitiesFindAllAudits({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkAndRideFacilitiesFindAllAuditsQueryKey(options),
  });

export const backendApiParkAndRideFacilitiesFindOneAuditQueryKey = (
  options: Options<ParkAndRideFacilitiesFindOneAuditData>,
) => createQueryKey('parkAndRideFacilitiesFindOneAudit', options);

export const backendApiParkAndRideFacilitiesFindOneAuditOptions = (
  options: Options<ParkAndRideFacilitiesFindOneAuditData>,
) =>
  queryOptions<
    ParkAndRideFacilitiesFindOneAuditResponse,
    DefaultError,
    ParkAndRideFacilitiesFindOneAuditResponse,
    ReturnType<typeof backendApiParkAndRideFacilitiesFindOneAuditQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkAndRideFacilitiesFindOneAudit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkAndRideFacilitiesFindOneAuditQueryKey(options),
  });

export const backendApiContactRequestsCreateQueryKey = (options: Options<ContactRequestsCreateData>) =>
  createQueryKey('contactRequestsCreate', options);

export const backendApiContactRequestsCreateOptions = (options: Options<ContactRequestsCreateData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof backendApiContactRequestsCreateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiContactRequestsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiContactRequestsCreateQueryKey(options),
  });

export const backendApiContactRequestsCreateMutation = (
  options?: Partial<Options<ContactRequestsCreateData>>,
): UseMutationOptions<unknown, DefaultError, Options<ContactRequestsCreateData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ContactRequestsCreateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await backendApiContactRequestsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const backendApiParkingDataFindAllLatestParkingFacilityDataQueryKey = (
  options?: Options<ParkingDataFindAllLatestParkingFacilityDataData>,
) => createQueryKey('parkingDataFindAllLatestParkingFacilityData', options);

export const backendApiParkingDataFindAllLatestParkingFacilityDataOptions = (
  options?: Options<ParkingDataFindAllLatestParkingFacilityDataData>,
) =>
  queryOptions<
    ParkingDataFindAllLatestParkingFacilityDataResponse,
    DefaultError,
    ParkingDataFindAllLatestParkingFacilityDataResponse,
    ReturnType<typeof backendApiParkingDataFindAllLatestParkingFacilityDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkingDataFindAllLatestParkingFacilityData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkingDataFindAllLatestParkingFacilityDataQueryKey(options),
  });

export const backendApiParkingDataFindAllParkingFacilityDataQueryKey = (
  options?: Options<ParkingDataFindAllParkingFacilityDataData>,
) => createQueryKey('parkingDataFindAllParkingFacilityData', options);

export const backendApiParkingDataFindAllParkingFacilityDataOptions = (
  options?: Options<ParkingDataFindAllParkingFacilityDataData>,
) =>
  queryOptions<
    ParkingDataFindAllParkingFacilityDataResponse,
    DefaultError,
    ParkingDataFindAllParkingFacilityDataResponse,
    ReturnType<typeof backendApiParkingDataFindAllParkingFacilityDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkingDataFindAllParkingFacilityData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkingDataFindAllParkingFacilityDataQueryKey(options),
  });

export const backendApiParkingDataFindAllLatestParkAndRideFacilityDataQueryKey = (
  options?: Options<ParkingDataFindAllLatestParkAndRideFacilityDataData>,
) => createQueryKey('parkingDataFindAllLatestParkAndRideFacilityData', options);

export const backendApiParkingDataFindAllLatestParkAndRideFacilityDataOptions = (
  options?: Options<ParkingDataFindAllLatestParkAndRideFacilityDataData>,
) =>
  queryOptions<
    ParkingDataFindAllLatestParkAndRideFacilityDataResponse,
    DefaultError,
    ParkingDataFindAllLatestParkAndRideFacilityDataResponse,
    ReturnType<typeof backendApiParkingDataFindAllLatestParkAndRideFacilityDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkingDataFindAllLatestParkAndRideFacilityData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkingDataFindAllLatestParkAndRideFacilityDataQueryKey(options),
  });

export const backendApiParkingDataFindAllParkAndRideFacilityDataQueryKey = (
  options?: Options<ParkingDataFindAllParkAndRideFacilityDataData>,
) => createQueryKey('parkingDataFindAllParkAndRideFacilityData', options);

export const backendApiParkingDataFindAllParkAndRideFacilityDataOptions = (
  options?: Options<ParkingDataFindAllParkAndRideFacilityDataData>,
) =>
  queryOptions<
    ParkingDataFindAllParkAndRideFacilityDataResponse,
    DefaultError,
    ParkingDataFindAllParkAndRideFacilityDataResponse,
    ReturnType<typeof backendApiParkingDataFindAllParkAndRideFacilityDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backendApiParkingDataFindAllParkAndRideFacilityData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: backendApiParkingDataFindAllParkAndRideFacilityDataQueryKey(options),
  });
